export default __webpack_public_path__ + "d3178bb8738f28729ed0f8aa46651027.svg";